import React from 'react';
import CompetitionStepContainer from '../../../../components/competition/CompetitionStepContainer';

/**
 * CompetitionStep - Registration flow step for managing competition routines
 */
const CompetitionStep = (props) => {
  // Simple pass-through to the CompetitionStepContainer
  return <CompetitionStepContainer {...props} />;
};

export default CompetitionStep;